import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import some from 'lodash/some';
import Money from '../../components/Money';
import CustomTip from '../containers/CustomTip';
import { tipShape } from '../../shapes';

const Tip = ({ tips, onTipSelect, on, off, toggled, hasCustomTip }) => (
  <div>
    <div className="c-heading c-heading--huge u-mb u-show-for-large-and-up">Tip</div>
    <div className="c-heading c-heading--huge u-mb- u-text-center u-hide-for-large-and-up">Tip</div>
    <div className="u-text-center layout layout--flush u--ml- large-and-up--ml u-mb-">
      {tips.map((tip, i) => {
        if (!tip.amount && !some(tips, 'amount')) return null;
        return (
          <div className="layout__item u-pl- large-and-up-pl u-1/5" key={tip.value || tip.amount}>
            <div className="c-select-btn">
              <input
                className="c-select-btn__input"
                type="radio"
                name="radio-reserve"
                id={`tip${i}`}
                onChange={() => onTipSelect(tip.flat ? tip.amount : tip.value)}
                checked={tip.active}
              />
              <label className="c-select-btn__label" htmlFor={`tip${i}`}>
                <div className="c-heading c-heading--huge">
                  {(tip.value || tip.flat) ? <Money>{tip.amount}</Money> : 'None'}
                </div>
                <div className="epsilon u-co-gray-1 u-type--bold u--mt-- u-show-for-large-and-up">{tip.desc}</div>
              </label>
            </div>
          </div>
        );
      })}
    </div>
    <div className="u-text-center u-mt">
      <button
        type="button"
        className={classnames('c-btn c-btn--default', { 'is-selected': hasCustomTip })}
        onClick={on}
      >
        {some(tips, 'amount') ? 'Custom Tip' : 'Add Tip'}
      </button>
      {toggled && <CustomTip close={off} />}
    </div>
  </div>
);
Tip.propTypes = {
  tips: PropTypes.arrayOf(tipShape),
  onTipSelect: PropTypes.func,
  on: PropTypes.func.isRequired,
  off: PropTypes.func.isRequired,
  toggled: PropTypes.bool.isRequired,
  hasCustomTip: PropTypes.bool.isRequired,
};
Tip.defaultProps = {
  tips: [],
  onTipSelect: null,
};

export default Tip;



// WEBPACK FOOTER //
// ./src/app/reservation/components/Tip.jsx